// JSON-LD Schema generators for Leapifyes

const SITE_URL = 'https://www.leapifyes.com';
const LOGO_URL = 'https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1772800285/logo_de_leapifyes_circular_elr6v1.jpg';
const PHONE = '+34694214849';
const EMAIL = 'info@leapifyes.com';

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  "name": "Leapifyes",
  "legalName": "DigitalLeap Solutions S.L.U.",
  "url": SITE_URL,
  "logo": {
    "@type": "ImageObject",
    "url": LOGO_URL,
    "width": 500,
    "height": 500
  },
  "image": LOGO_URL,
  "description": "Consultora de transformación digital en Barcelona. Agentes IA, automatización, desarrollo web y sistemas a medida para pymes y autónomos.",
  "founder": {
    "@type": "Person",
    "name": "Ricardo Serrano",
    "jobTitle": "Fundador y CEO",
    "url": "https://www.linkedin.com/in/ricardoserrano"
  },
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Barcelona",
    "addressRegion": "Cataluña",
    "addressCountry": "ES"
  },
  "areaServed": [
    { "@type": "City", "name": "Barcelona" },
    { "@type": "City", "name": "Badalona" },
    { "@type": "City", "name": "L'Hospitalet de Llobregat" },
    { "@type": "City", "name": "Sabadell" },
    { "@type": "City", "name": "Terrassa" },
    { "@type": "AdministrativeArea", "name": "Cataluña" },
    { "@type": "Country", "name": "España" }
  ],
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "sales",
      "telephone": PHONE,
      "email": EMAIL,
      "availableLanguage": ["Spanish", "Catalan", "English"]
    },
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "telephone": PHONE,
      "email": EMAIL,
      "availableLanguage": ["Spanish", "Catalan"]
    }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/leapifyes",
    "https://www.instagram.com/leapifyes",
    "https://twitter.com/leapifyes"
  ]
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  "url": SITE_URL,
  "name": "Leapifyes",
  "description": "Transformación digital y agentes de IA para empresas en Barcelona y España",
  "inLanguage": "es-ES",
  "publisher": { "@id": `${SITE_URL}/#organization` },
  "potentialAction": {
    "@type": "SearchAction",
    "target": { "@type": "EntryPoint", "urlTemplate": `${SITE_URL}/recursos?q={search_term_string}` },
    "query-input": "required name=search_term_string"
  }
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#localbusiness`,
  "name": "Leapifyes",
  "alternateName": "DigitalLeap Solutions S.L.U.",
  "image": LOGO_URL,
  "url": SITE_URL,
  "telephone": PHONE,
  "email": EMAIL,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Barcelona",
    "addressRegion": "Cataluña",
    "postalCode": "08001",
    "addressCountry": "ES"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 41.3851,
    "longitude": 2.1734
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "18:00"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "4",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": [
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5" },
      "author": { "@type": "Person", "name": "Clínica dental, Badalona" },
      "reviewBody": "Implantaron un sistema de recordatorios automatizados que redujo nuestro absentismo un 22%. El equipo trabaja con más orden y menos llamadas perdidas."
    },
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5" },
      "author": { "@type": "Person", "name": "Empresa de reformas, L'Hospitalet" },
      "reviewBody": "MANDO nos permitió presupuestar más rápido y hacer seguimiento real de cada obra. Pasamos a gestionar 3 obras más al mes sin contratar más personal."
    }
  ],
  "priceRange": "€€",
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": 41.3851,
      "longitude": 2.1734
    },
    "geoRadius": "150000"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicios de Transformación Digital",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Transformación Digital" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Agentes IA y Automatización" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Desarrollo Web a Medida" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ERP y CRM a Medida" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Sistemas a Medida" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Cumplimiento RGPD" } },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "SoftwareApplication",
          "name": "Agente IA para Pymes",
          "description": "Agente de inteligencia artificial listo para usar por pymes. Atención 24/7 por WhatsApp, web y email. Sin desarrollo técnico.",
          "applicationCategory": "BusinessApplication",
          "url": "https://ia.leapifyes.com",
          "offers": { "@type": "Offer", "price": "0", "priceCurrency": "EUR", "description": "Prueba gratuita disponible" }
        }
      }
    ]
  },
  "sameAs": [
    "https://www.linkedin.com/company/leapifyes",
    "https://www.instagram.com/leapifyes"
  ]
};

export const serviceSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/soluciones/transformacion-digital#service`,
    "name": "Transformación Digital para Pymes",
    "description": "Digitalizamos tus procesos con enfoque humano. Automatización inteligente, flujos optimizados y sistemas que trabajan para ti.",
    "provider": { "@id": `${SITE_URL}/#organization` },
    "areaServed": [{ "@type": "City", "name": "Barcelona" }, { "@type": "Country", "name": "España" }],
    "serviceType": "Consultoría de Transformación Digital",
    "url": `${SITE_URL}/soluciones/transformacion-digital`
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/soluciones/agentes-ia#service`,
    "name": "Agentes de IA y Automatización",
    "description": "Agentes conversacionales que atienden, cualifican y convierten 24/7. WhatsApp, web y email sin intervención manual.",
    "provider": { "@id": `${SITE_URL}/#organization` },
    "areaServed": [{ "@type": "City", "name": "Barcelona" }, { "@type": "Country", "name": "España" }],
    "serviceType": "Desarrollo de Agentes de Inteligencia Artificial",
    "url": `${SITE_URL}/soluciones/agentes-ia`
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/soluciones/desarrollo-web#service`,
    "name": "Desarrollo Web a Medida",
    "description": "Webs profesionales, landing pages y apps web que convierten. SEO técnico incluido desde el primer día.",
    "provider": { "@id": `${SITE_URL}/#organization` },
    "areaServed": [{ "@type": "City", "name": "Barcelona" }, { "@type": "Country", "name": "España" }],
    "serviceType": "Desarrollo Web",
    "url": `${SITE_URL}/soluciones/desarrollo-web`
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/soluciones/erp-crm#service`,
    "name": "ERP y CRM a Medida",
    "description": "Implementación y desarrollo de sistemas ERP y CRM adaptados a tu sector. Zoho CRM, Salesforce y soluciones propias.",
    "provider": { "@id": `${SITE_URL}/#organization` },
    "areaServed": [{ "@type": "City", "name": "Barcelona" }, { "@type": "Country", "name": "España" }],
    "serviceType": "Implementación ERP y CRM",
    "url": `${SITE_URL}/soluciones/erp-crm`
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/soluciones/sistemas-medida#service`,
    "name": "Software y Sistemas a Medida",
    "description": "Aplicaciones web, SaaS e integraciones API diseñadas exactamente para tu negocio.",
    "provider": { "@id": `${SITE_URL}/#organization` },
    "areaServed": [{ "@type": "City", "name": "Barcelona" }, { "@type": "Country", "name": "España" }],
    "serviceType": "Desarrollo de Software a Medida",
    "url": `${SITE_URL}/soluciones/sistemas-medida`
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/soluciones/cumplimiento-rgpd#service`,
    "name": "Cumplimiento RGPD y e-Factura",
    "description": "RGPD, LOPD, e-factura y Verifactu sin dolor. Diagnóstico, implementación y auditoría continua.",
    "provider": { "@id": `${SITE_URL}/#organization` },
    "areaServed": [{ "@type": "City", "name": "Barcelona" }, { "@type": "Country", "name": "España" }],
    "serviceType": "Consultoría de Cumplimiento Normativo",
    "url": `${SITE_URL}/soluciones/cumplimiento-rgpd`
  }
];

export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${SITE_URL}${item.path}`
  }))
});

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const generateWebPageSchema = ({ title, description, path, datePublished = '2024-01-01', dateModified = '2026-04-30' }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${SITE_URL}${path}#webpage`,
  "url": `${SITE_URL}${path}`,
  "name": title,
  "description": description,
  "inLanguage": "es-ES",
  "isPartOf": { "@id": `${SITE_URL}/#website` },
  "about": { "@id": `${SITE_URL}/#organization` },
  "datePublished": datePublished,
  "dateModified": dateModified
});

export const generateServicePageSchema = ({ solution, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${SITE_URL}${path}#service`,
  "name": solution.title,
  "description": solution.description,
  "provider": { "@id": `${SITE_URL}/#organization` },
  "areaServed": [
    { "@type": "City", "name": "Barcelona" },
    { "@type": "Country", "name": "España" }
  ],
  "serviceType": solution.title,
  "url": `${SITE_URL}${path}`
});

export const generateProductSchema = ({ product, path }) => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": `${SITE_URL}${path}#software`,
  "name": product.name,
  "description": product.hero?.subtitle || product.descriptionMenu,
  "applicationCategory": "LifestyleApplication",
  "operatingSystem": "iOS",
  "url": `${SITE_URL}${path}`,
  "installUrl": product.appStoreUrl,
  "publisher": { "@id": `${SITE_URL}/#organization` },
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "EUR",
    "description": "Gratis para clientes. Modelo de suscripción sin comisiones para profesionales."
  },
  "areaServed": { "@type": "Country", "name": "España" }
});

export const generateBlogPostSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": post.title,
  "description": post.excerpt,
  "datePublished": post.date,
  "dateModified": post.date,
  "author": { "@type": "Organization", "name": "Leapifyes", "@id": `${SITE_URL}/#organization` },
  "publisher": { "@id": `${SITE_URL}/#organization` },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `${SITE_URL}/recursos/${post.slug}`
  }
});

export const schemaToString = (schema) => JSON.stringify(schema);

// Combined home page schema (all schemas merged for performance)
export const getHomeSchemas = () => [
  organizationSchema,
  websiteSchema,
  localBusinessSchema,
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Qué es la transformación digital para pymes?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "La transformación digital para pymes es el proceso de integrar tecnología en todas las áreas del negocio para mejorar la eficiencia, reducir costes y aumentar las ventas. Incluye digitalización de procesos, automatización de tareas repetitivas, implementación de CRM y agentes de IA."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto cuesta digitalizar una empresa en Barcelona?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "En Leapifyes los planes de transformación digital comienzan desde 497€/mes. El retorno de inversión medio se consigue entre 3 y 6 meses. No cobramos por horas, sino por resultados, con planes mensuales sin permanencia mínima."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué son los agentes de IA para empresas?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Los agentes de IA son asistentes virtuales inteligentes que atienden clientes, responden preguntas, cualifican leads y hasta cierran ventas de forma autónoma 24/7. Funcionan en WhatsApp, web, email y teléfono sin intervención manual."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto tiempo tarda un proyecto de digitalización?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Con el método Leapifyes, los primeros resultados se ven en la primera semana (quick wins). Un proyecto estándar dura entre 4 y 12 semanas según el alcance. Siempre empezamos con un diagnóstico gratuito de 30 minutos."
        }
      },
      {
        "@type": "Question",
        "name": "¿Trabajáis con pymes de toda España o solo en Barcelona?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Tenemos base en Barcelona pero trabajamos con empresas de toda España de forma remota. También atendemos toda Cataluña de forma presencial: Barcelona, Girona, Tarragona y Lleida."
        }
      },
      {
        "@type": "Question",
        "name": "¿Necesito conocimientos técnicos para trabajar con vosotros?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Nos encargamos de toda la parte técnica. Nuestro método está diseñado para que tú y tu equipo podáis usar las herramientas desde el primer día sin necesitar conocimientos técnicos. Formamos a tu equipo incluido."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué es un agente de IA para WhatsApp Business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Un agente de IA para WhatsApp Business es un asistente virtual que responde automáticamente a clientes a través de WhatsApp. Puede responder preguntas frecuentes, cualificar leads, enviar información de productos, gestionar citas y escalar al agente humano cuando es necesario. Opera 24 horas al día, 7 días a la semana, sin intervención manual."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto cuesta un agente de IA para mi empresa?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "En Leapifyes el acceso al Agente IA para Pymes comienza con una prueba gratuita en ia.leapifyes.com. Para proyectos de IA a medida para empresas, los precios parten desde 497€/mes según funcionalidades y volumen de conversaciones. Siempre hacemos un diagnóstico gratuito antes de proponer ningún precio."
        }
      },
      {
        "@type": "Question",
        "name": "¿Podéis integrar IA en el CRM o ERP que ya tengo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí. Integramos agentes de IA y automatizaciones con los sistemas existentes: Zoho CRM, Salesforce, HubSpot, sistemas propios, bases de datos y cualquier aplicación con API. No es necesario cambiar tu stack actual para empezar a usar IA."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué es MANDO by Leapifyes?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "MANDO by Leapifyes es un ERP diseñado específicamente para empresas de reformas y construcción. Permite gestionar presupuestos, seguimiento de obras, control de costes, facturación legal y comunicación con clientes desde una sola plataforma. Disponible en mando.leapifyes.com."
        }
      },
      {
        "@type": "Question",
        "name": "¿Hacéis proyectos de transformación digital fuera de Cataluña?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí. Aunque tenemos base en Barcelona y atendemos presencialmente toda Cataluña, trabajamos con empresas de toda España de forma remota. Tenemos clientes en Madrid, Valencia, Bilbao, Sevilla y otras ciudades. El modelo remoto nos permite proyectar la misma calidad en cualquier punto del país."
        }
      }
    ]
  }
];
